export { default as h1 } from "./h1";
export { default as h2 } from "./h2";
export { default as h3 } from "./h3";
export { default as h4 } from "./h4";
export { default as h5 } from "./h5";
export { default as h6 } from "./h6";
export { default as a } from "./a";
export { default as img } from "./img";
export { default as table } from "./table";
export { default as p } from "./p";
export { default as code } from "./code";


